import ChessRestClient from '@/Api/ChessRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useManageStaffApi(handleOnSuccess, handleOnError) {
  const mutation = useMutation({
    mutationFn: async details => {
      // Extract API password from details and set it in headers
      const apiPassword = details.apiPassword;

      // Remove apiPassword from the payload before sending
      const {apiPassword: _, ...payloadWithoutPassword} = details;

      // Configure headers with the API password
      const headers = {};
      if (apiPassword) {
        headers['API-Password'] = apiPassword;
      }

      // For "check" action, we use a GET request to fetch the user's status
      if (details.action === 'check') {
        try {
          const response = await ChessRestClient.get(
            `subscription/v1/get-staff-access?mobile_number=${details.mobile_number}`,
            {headers},
          );

          if (response.data && response.data.user) {
            return {
              success: true,
              message: `User found: ${
                response.data.user.display_name ||
                response.data.user.mobile_number
              }`,
              is_staff: response.data.user.is_staff || false,
            };
          } else {
            throw new Error('User not found');
          }
        } catch (error) {
          throw error;
        }
      } else {
        // For grant/remove actions, use the update_staff_status endpoint
        const response = await ChessRestClient.post(
          'subscription/v1/update-staff-access',
          payloadWithoutPassword,
          {headers},
        );

        return response.data;
      }
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return {
    ...mutation,
  };
}
